<template>
	<div class="ScrollBox">
		<van-nav-bar
		fixed
		:border="false"
		:title="$t('user.office[3]')"
		left-arrow
		@click-left="$router.go(-1)"
		/>
		<div style="padding-top:10%;text-align: center;">
			<div style="margin-top: 0.6rem;">
				<img :src="'./static/images/Informasi-posisi-saya.png'" style="width: 100%;"/>
				<router-link to="/user/positions" style="color: #333;"><div class="btn" >{{ $t("user.office[0]")}}</div></router-link>
			</div>
			<div style="margin-top: 0.625rem;">
				<img :src="'./static/images/Detail-promosi-jabatan.png'" style="width: 100%;"/>
				<router-link to="/user/apply" style="color: #333;"><div class="btn" >{{ $t("user.office[1]")}}</div></router-link>
			</div>
			<div style="margin-top: 0.625rem;">
				<img :src="'./static/images/Deskripsi-pekerjaan.png'" style="width: 100%;"/>
				<div class="btn"  @click="openShow(InitData.serviceList[0])">{{ $t("user.office[2]")}}</div>
			</div>
			<van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
			  <div class="ScrollBox" style="padding: 16px 20px;">
			    <h3 style="text-align: center;margin-bottom: 20px;color:#333">{{infoData.title}}</h3>
			    <div class="Content" style="text-align: justify;color:#333" v-html="infoData.content"></div>
			  </div>
			</van-popup>
			
		</div>
	</div>
</template>

<script>
	export default {
		name:"",
		data(){
			return {
				showCon: false,
				infoData:''
			}
		},
		computed: {
		},
		watch: {
		},
		created() {
			this.$parent.navBarTitle = this.$t("user.office[3]")
			this.$Model.GetUserInfo();
		},
		mounted() {
		},
		activated() {},
		destroyed() {},
		methods: {
			
			getStr(n1,n2) {
				return n1+"/"+n2;
			},
			openShow(data) {
			  this.showCon = true
			  this.infoData = data
			}
		}
	}
</script>

<style scoped>
	.btn{
		background-color: #ffffff;
		padding: 0.625rem 0;
		font-size: 1rem;
		font-weight: 700;
	}
</style>